<!--This is PDF template for pdf download and pdf package not supported classes for styles for inline css added-->
<!doctype html>
<html lang="en">
  <body id="pdf-data" #pdfContent style="width: 100%; max-width: 600px">
    <div class="pdf-content">
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":"5%"}'>
          <img
            [src]="printData?.logo"
            alt="Organization Logo"
            style="width: 100px; height: auto; object-fit: contain" />
        </div>

        <div data-pdfmake='{"width":"*", "margin": [10, 0]}'>
          <div class="desc" style="text-align: right">
            {{ printData?.orgDetail?.address }}
          </div>
          <div class="address" style="text-align: right">
            {{ printData?.orgDetail?.city }}, {{ printData?.orgDetail?.state }},
            {{ printData?.orgDetail?.country }},
            {{ printData?.orgDetail?.zipCode }}
          </div>
        </div>
      </div>

      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />

      <div data-pdfmake-type="columns">
        <div class="title" data-pdfmake='{"width":"*"}'>
          {{ printData?.feedbackDetail?.studentInfo?.studentFirstName || '-' }}
          {{ printData?.feedbackDetail?.studentInfo?.studentLastName || '-' }}
        </div>
        <div style="width: auto"></div>
        <div
          class="title"
          style="text-align: right"
          data-pdfmake='{"width":"*"}'>
          <b>Supervisor : </b>
          {{ printData?.feedbackDetail?.studentInfo?.supervisorName || '-' }}
        </div>
      </div>

      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />

      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":"*"}'>
          <div class="datalabel">Gender</div>
          <div class="dataValue">
            <b>
              {{
                printData?.feedbackDetail?.studentInfo?.studentGender || '-'
              }}</b
            >
          </div>
        </div>
        <div style="width: auto">
          <div class="datalabel">Student School</div>
          <div class="dataValue">
            <b>{{ printData?.orgDetail?.organizationName || '-' }}</b>
          </div>
        </div>
        <div style="text-align: left" data-pdfmake='{"width":"*"}'>
          <div class="datalabel">Date Of Birth</div>
          <div class="dataValue">
            <b>{{
              printData?.feedbackDetail?.studentInfo?.studentDateOfBirth ?? null
                | date: 'MM/dd/yyyy'
            }}</b>
          </div>
        </div>
      </div>
      <br />
      <div data-pdfmake-type="columns">
        <div style="text-align: left" data-pdfmake='{"width":"*"}'>
          <div class="datalabel">Assessment Period</div>
          <div class="dataValue">
            <b
              >{{
                printData?.feedbackDetail?.studentInfo?.frequencyDays ?? 0
              }}
              days</b
            >
          </div>
        </div>
      </div>
      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />
      <ng-container
        *ngIf="printData?.feedbackDetail?.behaviorSpecificQuestions?.length">
        <table
          data-pdfmake='{"widths": ["*"], "heights": 20, "dontBreakRows": true, "layout": {  "hLineColor": "#eaecf0",  "vLineColor": "#eaecf0"}}'>
          <tr>
            <td
              style="font-size: 16px"
              data-pdfmake='{"fillColor": "#17b26a", "color": "#ffffff", "margin": [0,7,0,7]}'>
              <b>Behavior-Specific Summary</b>
            </td>
          </tr>
        </table>
        <div data-pdfmake='{"margin": [0,0,0,7]}' data-pdfmake-type="columns">
          <div data-pdfmake='{"width":175}' class="datalabel">
            Behavior Category :
          </div>
          <div data-pdfmake='{"width":"*"}' class="datalabel">
            <b
              >{{
                printData?.feedbackDetail?.behaviorSpecificQuestions?.[0]
                  ?.behaviorCategoryName || '-'
              }}
            </b>
          </div>
        </div>
        <div data-pdfmake='{"margin": [0,0,0,7]}' data-pdfmake-type="columns">
          <div data-pdfmake='{"width":175}' class="datalabel">
            Behavior management rating :
          </div>
          <div data-pdfmake='{"width":"*"}' class="datalabel">
            <b
              >{{
                printData?.feedbackDetail?.behaviorSpecificQuestions?.[0]
                  ?.ratingScale || '-'
              }}
            </b>
          </div>
        </div>
        <div data-pdfmake='{"margin": [0,0,0,7]}' data-pdfmake-type="columns">
          <div data-pdfmake='{"width":175}' class="datalabel">
            Improvement rating :
          </div>
          <div data-pdfmake='{"width":"*"}' class="datalabel">
            <b
              >{{
                printData?.feedbackDetail?.behaviorSpecificQuestions?.[1]
                  ?.ratingScale || '-'
              }}
            </b>
          </div>
        </div>
        <div data-pdfmake='{"margin": [0,0,0,7]}' data-pdfmake-type="columns">
          <div data-pdfmake='{"width":175}' class="datalabel">
            Intervention effectiveness rating :
          </div>
          <div data-pdfmake='{"width":"*"}' class="datalabel">
            <b
              >{{
                printData?.feedbackDetail?.behaviorSpecificQuestions?.[2]
                  ?.ratingScale || '-'
              }}
            </b>
          </div>
        </div>
        <div data-pdfmake='{"margin": [0,0,0,7]}' data-pdfmake-type="columns">
          <div data-pdfmake='{"width":175}' class="datalabel">
            Academic impact score :
          </div>
          <div data-pdfmake='{"width":"*"}' class="datalabel">
            <b
              >{{
                printData?.feedbackDetail?.behaviorSpecificQuestions?.[4]
                  ?.ratingScale || '-'
              }}
            </b>
          </div>
        </div>
        <div data-pdfmake='{"margin": [0,0,0,7]}' data-pdfmake-type="columns">
          <div data-pdfmake='{"width":175}' class="datalabel">Comments :</div>
          <div data-pdfmake='{"width":"*"}' class="datalabel">
            <b
              >{{
                printData?.feedbackDetail?.behaviorSpecificQuestions?.[3]
                  ?.answerText || '-'
              }}
            </b>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="printData?.graphImages?.length">
        <table
          data-pdfmake='{"widths": ["*"], "heights": 20, "dontBreakRows": true, "layout": {  "hLineColor": "#eaecf0",  "vLineColor": "#eaecf0"}}'>
          <tr>
            <td
              style="font-size: 16px"
              data-pdfmake='{"fillColor": "#17b26a", "color": "#ffffff", "margin": [0,7,0,7]}'>
              <b>Behavior Graphs</b>
            </td>
          </tr>
        </table>
        <div data-pdfmake='{"width":"*"}'>
          <div *ngFor="let imgSrc of printData?.graphImages; let i = index">
            <img
              data-pdfmake='{"width":552}'
              [src]="imgSrc"
              [alt]="'Chart Image_' + i"
              class="chartImage" />
          </div>
        </div>
      </ng-container>
      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />

      <table
        data-pdfmake='{"widths": ["*"], "heights": 20, "dontBreakRows": true, "layout": {  "hLineColor": "#eaecf0",  "vLineColor": "#eaecf0"}}'>
        <tr>
          <td
            style="font-size: 16px"
            data-pdfmake='{"fillColor": "#17b26a", "color": "#ffffff", "margin": [0,7,0,7]}'>
            <b>Overall Scores</b>
          </td>
        </tr>
      </table>
      <div data-pdfmake='{"margin": [0,0,0,7]}' data-pdfmake-type="columns">
        <div data-pdfmake='{"width":175}' class="datalabel">
          General behavior rating :
        </div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <b
            >{{
              printData?.feedbackDetail?.overallScores?.generalBehaviorRating
            }}
          </b>
        </div>
      </div>
      <div data-pdfmake='{"margin": [0,0,0,7]}' data-pdfmake-type="columns">
        <div data-pdfmake='{"width":175}' class="datalabel">
          Behavior-specific score :
        </div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <b
            >{{
              printData?.feedbackDetail?.overallScores?.behaviorSpecificScore
            }}
          </b>
        </div>
      </div>
      <div data-pdfmake='{"margin": [0,0,0,7]}' data-pdfmake-type="columns">
        <div data-pdfmake='{"width":175}' class="datalabel">
          Intervention & support score :
        </div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <b
            >{{
              printData?.feedbackDetail?.overallScores?.interventionSupportScore
            }}
          </b>
        </div>
      </div>
      <div data-pdfmake='{"margin": [0,0,0,7]}' data-pdfmake-type="columns">
        <div data-pdfmake='{"width":175}' class="datalabel">
          Stakeholder score :
        </div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <b
            >{{ printData?.feedbackDetail?.overallScores?.stakeholderScore }}
          </b>
        </div>
      </div>
      <div
        data-pdfmake='{"margin": [0,0,0,7]}'
        data-pdfmake-type="columns"
        *ngIf="
          printData?.feedbackDetail?.selfAssessmentScores &&
          printData?.feedbackDetail?.selfAssessmentScores?.length &&
          printData?.feedbackDetail?.selfAssessmentScores?.[0]
        ">
        <div data-pdfmake='{"width":175}' class="datalabel">
          Teacher self-assessment scores :
        </div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <b
            >{{
              printData?.feedbackDetail?.selfAssessmentScores?.[0]
                ?.overallScore || '-'
            }}
          </b>
        </div>
      </div>
      <div
        data-pdfmake='{"margin": [0,0,0,7]}'
        data-pdfmake-type="columns"
        *ngIf="
          printData?.feedbackDetail?.selfAssessmentScores &&
          printData?.feedbackDetail?.selfAssessmentScores?.length &&
          printData?.feedbackDetail?.selfAssessmentScores?.[1]
        ">
        <div data-pdfmake='{"width":175}' class="datalabel">
          Student-assessment scores:
        </div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <b
            >{{
              printData?.feedbackDetail?.selfAssessmentScores?.[1]
                ?.overallScore || '-'
            }}
          </b>
        </div>
      </div>
      <div data-pdfmake='{"margin": [0,0,0,7]}' data-pdfmake-type="columns">
        <div data-pdfmake='{"width":175}' class="datalabel">
          Overall behavior score :
        </div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <b>{{ printData?.feedbackDetail?.overallScores?.overallScore }} </b>
        </div>
      </div>
      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />
      <table
        data-pdfmake='{"widths": ["*"], "heights": 20, "dontBreakRows": true, "layout": {  "hLineColor": "#eaecf0",  "vLineColor": "#eaecf0"}}'>
        <tr>
          <td
            style="font-size: 16px"
            data-pdfmake='{"fillColor": "#17b26a", "color": "#ffffff", "margin": [0,7,0,7]}'>
            <b>Support Recommendations</b>
          </td>
        </tr>
      </table>
      <div data-pdfmake='{"margin": [0,0,0,7]}' data-pdfmake-type="columns">
        <div data-pdfmake='{"width":175}' class="datalabel">
          Level of support :
        </div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <b
            >{{
              printData?.feedbackDetail?.overallScores?.levelOfSupport || '-'
            }}
          </b>
        </div>
      </div>
      <div data-pdfmake='{"margin": [0,0,0,7]}' data-pdfmake-type="columns">
        <div data-pdfmake='{"width":175}' class="datalabel">
          Recommendation based on score :
        </div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <b
            >{{
              getRecommendationBasedOnScore(
                printData?.feedbackDetail?.overallScores?.levelOfSupport
              )
            }}
          </b>
        </div>
      </div>
      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />
      <ng-container
        *ngIf="
          printData?.feedbackDetail?.interventionAndSupportFeedbacks?.length
        ">
        <table
          data-pdfmake='{"widths": ["*"], "heights": 20, "dontBreakRows": true, "layout": {  "hLineColor": "#eaecf0",  "vLineColor": "#eaecf0"}}'>
          <tr>
            <td
              style="font-size: 16px"
              data-pdfmake='{"fillColor": "#17b26a", "color": "#ffffff", "margin": [0,7,0,7]}'>
              <b>Intervention Review</b>
            </td>
          </tr>
        </table>
        <div data-pdfmake='{"margin": [0,0,0,7]}' data-pdfmake-type="columns">
          <div data-pdfmake='{"width":175}' class="datalabel">
            Requested changes to plan :
          </div>
          <div data-pdfmake='{"width":"*"}' class="datalabel">
            <b
              >{{
                printData?.feedbackDetail?.interventionAndSupportFeedbacks?.[0]
                  ?.ratingScale === 5
                  ? 'No modifications requested'
                  : printData?.feedbackDetail
                      ?.interventionAndSupportFeedbacks?.[0]?.answerText
              }}
            </b>
          </div>
        </div>
        <div data-pdfmake='{"margin": [0,0,0,7]}' data-pdfmake-type="columns">
          <div data-pdfmake='{"width":175}' class="datalabel">
            Additional supports requested :
          </div>
          <div data-pdfmake='{"width":"*"}' class="datalabel">
            <b
              >{{
                printData?.feedbackDetail?.interventionAndSupportFeedbacks?.[1]
                  ?.ratingScale === 5
                  ? 'No modifications requested'
                  : printData?.feedbackDetail
                      ?.interventionAndSupportFeedbacks?.[1]?.answerText
              }}
            </b>
          </div>
        </div>
        <div data-pdfmake='{"margin": [0,0,0,7]}' data-pdfmake-type="columns">
          <div data-pdfmake='{"width":175}' class="datalabel">
            Admin review notes :
          </div>
          <div data-pdfmake='{"width":"*"}' class="datalabel">
            <b>{{ printData?.notes ? printData?.notes : '-' }} </b>
          </div>
        </div>
      </ng-container>
    </div>
  </body>
</html>
